import { PartialType } from '@nestjs/swagger';
import { CreatePosConfigDto } from './create-pos-config.dto';

export class UpdatePosConfigDto extends PartialType(CreatePosConfigDto) {}
